module.exports = __webpack_public_path__ + "img/pic_4.6d83423c.jpg";